import { TimeZoneContext } from "views/OfferProgramTerms/context/TimeZoneContext";
import { useProviderInitializedContext } from "hooks/useProviderInitializedContext";

export const useTimeZone = () => {
  return useProviderInitializedContext(TimeZoneContext);
};
